import { TurboMount } from "turbo-mount";
import { registerComponent } from "turbo-mount/react";
import TestComponent from "./components/TestComponent.jsx";

import MasteryMap from "./Courses/MasteryMap";
import StudyPathSideBar from "./Courses/StudyPathSideBar/index.jsx";
import OverallProgress from "./Courses/OverallProgress/index.jsx";
import RoadMap from "./Courses/RoadMap/";
import ProfileView from "./Profile/View";
import NoteGenerateButtons from "./Generate/Actions";
import StudyToolsActions from "./StudyTools";
import SnapshotView from "./Snapshot";
import FlashcardSetupModal from "./components/FlashcardSetupModal/FlashcardSetupModal";
import FlashcardReview from "./components/FlashCardReview";
import ProcessingModal from "./components/ProcessingModal";
import AvailableSoonModal from "./components/AvailableSoonModal";
import GlobalModalProvider from "./components/GlobalModalProvider";
import "./utils/globalModalManager";

// Pages
import CourseShow from "./page/Course/Show/index.jsx";
import CoursesIndex from "./page/Course/Index/index.jsx";
import CoursesNew from "./page/Course/New";
import QuestionCards from "./page/QuestionCards";
import Onboarding from "./page/Onboarding";
import Game2048 from "./components/Game2048";
import SnakeGame from "./components/SnakeGame";

const turboMount = new TurboMount();
registerComponent(turboMount, "TestComponent", TestComponent);
registerComponent(turboMount, "MasteryMap", MasteryMap);
registerComponent(turboMount, "OverallProgress", OverallProgress);
registerComponent(turboMount, "StudyPathSideBar", StudyPathSideBar);
registerComponent(turboMount, "RoadMap", RoadMap);
registerComponent(turboMount, "CourseShow", CourseShow);
registerComponent(turboMount, "CoursesIndex", CoursesIndex);
registerComponent(turboMount, "CoursesNew", CoursesNew);
registerComponent(turboMount, "QuestionCards", QuestionCards);
registerComponent(turboMount, "Game2048", Game2048);
registerComponent(turboMount, "SnakeGame", SnakeGame);
registerComponent(turboMount, "ProfileView", ProfileView);
registerComponent(turboMount, "NoteGenerateButtons", NoteGenerateButtons);
registerComponent(turboMount, "StudyToolsActions", StudyToolsActions);
registerComponent(turboMount, "SnapshotView", SnapshotView);
registerComponent(turboMount, "FlashcardSetupModal", FlashcardSetupModal);
registerComponent(turboMount, "FlashcardReview", FlashcardReview);
registerComponent(turboMount, "ProcessingModal", ProcessingModal);
registerComponent(turboMount, "AvailableSoonModal", AvailableSoonModal);
registerComponent(turboMount, "GlobalModalProvider", GlobalModalProvider);

// Onboarding
registerComponent(turboMount, "OnboardingPage", Onboarding);

// to register a component use:
// registerComponent(turboMount, "Hello", Hello); // where Hello is the imported the component

// to override the default controller use:
// registerComponent(turboMount, "Hello", Hello, HelloController); // where HelloController is a Stimulus controller extended from TurboMountController

// If you want to automatically register components use:
// import { registerComponents } from "turbo-mount/registerComponents/react";
// const controllers = import.meta.glob("/controllers/**/*_controller.js", { eager: true });
// const components = import.meta.glob("/components/**/*.jsx", { eager: true });
// registerComponents({ turboMount, components, controllers });
